import React from 'react';
import UserItem from './AccessRuleItem';
import List from 'components/list/List';
import { Grid } from '@mui/material';
import { AccessRule } from 'types/accessRule';

type AccessRulesListProps = {
  accessRules: AccessRule[];
};

const UserList: React.FC<AccessRulesListProps> = ({ accessRules }) => {
  return (
    <Grid container>
      <Grid size={12}>
        <List>
          {accessRules.map(rule => (
            <UserItem key={rule.id} accessRule={rule} />
          ))}
        </List>
      </Grid>
    </Grid>
  );
};

export default UserList;
